var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemChannelBlog = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M20 17.333V6.678A2.68 2.68 0 0 0 17.322 4H6.678A2.68 2.68 0 0 0 4 6.678v10.655zm-.362 1.334A2.68 2.68 0 0 1 17.322 20H6.678a2.68 2.68 0 0 1-2.315-1.333zM4 16v-1.333h16V16zm0-2.667V12h16v1.333z",
  clipRule: "evenodd"
})));
export default SvgGemChannelBlog;